import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["vgmWeight"];

  connect() {
    this.tareInput = this.element.querySelector("#container_tare_weight_kg");

    // basically means IF FCL
    if (this.tareInput) {
      this.tareWeight = parseInt(this.tareInput.value || 0);
      this.element.addEventListener("cortana:record_destroyed", () => this.updateVgmWeight());
    }
  }

  updateTareWeight() {
    this.tareWeight = parseInt(this.tareInput.value || 0);

    this.updateVgmWeight();
  }

  updateVgmWeight() {
    this.vgmWeight =
      [...this.element.querySelectorAll(".total-weight-input")].reduce((total, element) => {
        // Element is soft deleted, return 0 for total estimation
        if (element.closest(".list-group-item.d-none")) {
          return total;
        }

        total += parseInt(element.value);

        return total;
      }, 0) + this.tareWeight;

    this.vgmWeightTarget.value = this.vgmWeight;
  }
}
